module.exports = __webpack_public_path__ + "img/logo.cef69a4a.png";